// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".temporal-extent {\n  padding-left: 15px;\n}", "",{"version":3,"sources":["webpack://./src/components/searchfilter/temporal-extent.scss"],"names":[],"mappings":"AAEA;EACI,kBAAA;AADJ","sourcesContent":["@import '../../assets/css/variables-site/variables-site';\n\n.temporal-extent {\n    padding-left: 15px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
